import type { SuggestedAction, TriageCategory } from "../storage-schema";

export type Affordance = "reply" | "open" | "copy_otp" | "none";

/** Gate the model's suggested action by capability: reply needs repliable, copy_otp needs category=otp, else open. */
export function resolveAffordance(
  triage: { suggestedAction: SuggestedAction; category: TriageCategory },
  item: { repliable: boolean }
): Affordance {
  if (triage.suggestedAction === "reply") return item.repliable ? "reply" : "open";
  if (triage.suggestedAction === "copy_otp") return triage.category === "otp" ? "copy_otp" : "open";
  if (triage.suggestedAction === "open") return "open";
  return "none";
}
